var _g, _defs;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgChampagne = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3132_18696)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.7417 13.3333H20.2417L24.4084 21.6666C25.7884 24.4283 29.1467 25.5466 31.9084 24.1666C34.67 22.7866 35.7884 19.4283 34.4084 16.6666L32.7417 13.3333Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M39.8251 27.5883C39.4118 26.765 38.4101 26.4317 37.5884 26.8433L35.7467 27.765L33.3934 23.0583C35.0101 21.4017 35.5034 18.855 34.4101 16.6683L27.6551 3.15832C27.2418 2.33332 26.2418 1.99999 25.4184 2.41166L18.4001 5.92166C18.0034 6.11999 17.7301 6.45666 17.5884 6.84332L15.3934 5.74499C14.5701 5.33332 13.5701 5.66666 13.1584 6.48999L6.40342 20C5.31009 22.1867 5.80342 24.7333 7.42009 26.39L5.06675 31.0967L3.22509 30.175C2.40342 29.7633 1.40175 30.0967 0.988419 30.92C0.576752 31.7433 0.910085 32.745 1.73342 33.1567L8.40008 36.49C8.63842 36.61 8.89342 36.6667 9.14342 36.6667C9.75508 36.6667 10.3434 36.33 10.6368 35.745C11.0484 34.9217 10.7151 33.92 9.89175 33.5083L8.05009 32.5867L10.3601 27.9667C12.7568 28.425 15.2601 27.29 16.4051 25L19.5751 18.66L21.2418 15.3267L24.4084 21.6667C25.5534 23.9567 28.0567 25.0917 30.4534 24.6333L32.7634 29.2533L30.9218 30.175C30.0984 30.5867 29.7651 31.5883 30.1768 32.4117C30.4684 32.9967 31.0567 33.3333 31.6684 33.3333C31.9184 33.3333 32.1734 33.2767 32.4118 33.1583L39.0784 29.825C39.9018 29.4117 40.2368 28.4117 39.8251 27.5883Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.07005 16.6667H20.57L16.4034 25C15.0234 27.7617 11.665 28.88 8.90338 27.5C6.14172 26.12 5.02338 22.7617 6.40338 20L8.07005 16.6667Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3132_18696"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgChampagne, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/champagne.79cde723.svg";
export { ForwardRef as ReactComponent };